export * as customEmbeds from '@wix/auto_sdk_embeds_custom-embeds/meta';
